<template>
  <div class="w-full bg-trader-gray text-center overflow-y-auto p-2 gap-2 flex flex-col">

    <h2>Einkaufsbereiche:</h2>

    <div class="grid grid-cols-6 gap-2">
      <div v-for="(section, index) in shoppingSections" :key="section.id" class="flex">
        <div v-if="!(pageTeamIds.indexOf(section.id) >= 0)" class="w-2 rounded-tl rounded-bl"
             :style="`background-color: ${section.color};`"></div>

        <span class="inline-block w-full p-1 font-bold rounded cursor-pointer bg-white dark:bg-trader-dark-gray"
              :style="pageTeamIds.indexOf(section.id) >= 0 ? `background-color: ${section.color}; color: ${getBackgroundColor(section.color)}`: ``"
              @click="toggleTeam(section.id)"
              :data-ui="'EKB-'+ section.teamIcon"
              :title="section.teamIcon + ' ' + section.name">
                {{ section.teamIcon }}
          </span>
      </div>
    </div>

    <h2>Ausgewählte Einkaufsbereiche:</h2>

    <div class="grid-cols-6 grid gap-2">
      <div v-for="(section, index) in filteredShoppingSections" :key="section.id" class="flex">
        <div v-if="!(selectedTeamsForPlaceholder[selectedPlaceholder]?.indexOf(section.id) >= 0)"
             class="w-2 rounded-tl rounded-bl" :style="`background-color: ${section.color};`"></div>
        <span class="inline-block w-full p-1 font-bold rounded cursor-pointer  bg-white dark:bg-trader-dark-gray"
              :style="selectedTeamsForPlaceholder[selectedPlaceholder]?.indexOf(section.id) >= 0 ? `background-color: ${section.color}; color: ${getBackgroundColor(section.color)}` : ` `"
              @click="toggleTeamGrid(section.id)"
              :data-ui="'A-EKB-'+ section.teamIcon"
              :title="section.teamIcon + ' ' + section.name">
          {{ section.teamIcon }}
          </span>
      </div>
    </div>

    <TRSaveButton :is-loading="isLoading" :click-event="saveTeam" data-ui="button-save-ekb" :text-title="'Einkaufsbereich Speichern'">
    </TRSaveButton>


  </div>
</template>

<script>
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import SignalBus from "@/application/SignalBus";
import TRSaveButton from "@/components/Base/v2/TRSaveButton.vue";

export default {
  name: "CEditPurchaser",
  components: {TRSaveButton},
  computed: {
    filteredShoppingSections: function () {
      return this.shoppingSections.filter(section => this.pageTeamIds.includes(section.id));
    }
  },
  data() {
    return {
      shoppingSections: [],
      pageTeamIds: [],
      selectedTeamsForPlaceholder: {},
      colors: [],
      virtualId: null,
      isLoading: false
    };

  },
  props: {
    pageId: {
      type: Number,
      required: true
    },
    filteredPages: {
      type: Array,
      required: true
    },
    selectedPlaceholder: {
      type: Number,
      required: true
    },
    marketIds: {
      type: Array,
      required: true
    },
  },
  methods: {
    getShoppingSectionsFromPage() {

      return new Promise(async (resolve, reject) => {

        this.selectedTeamsForPlaceholder = {};
        this.filteredPages.forEach(p => p.borderActive = false);

        // Finden Sie das Element mit der spezifischen pageId und setzen Sie die borderActive Eigenschaft auf true
        let targetElement = this.filteredPages.find(element => element.pageId === this.pageId);

        if (targetElement === 0) {
          targetElement.borderActive = false;
        }
        if (targetElement) {
          targetElement.borderActive = true;
        }
        try {
          // Überprüfung, ob pageID einen Wert hat
          if (!this.pageId) {
            console.error("pageId is not set");
            return;
          }

          const response = await apolloClient.query({
            query: gql`
        query getShoppingSectionsFromPage($pageId: Int!) {
          getShoppingSectionsFromPage(pageId: $pageId) {
            pageID
            teams {
                id
                tag
                name
                color
            }
            teamsForPlaceholder {
              key
              value
            }
          }
        }
      `,
            variables: {
              pageId: this.pageId
            }
          });

          if (response.data.getShoppingSectionsFromPage) {
            const data = response.data.getShoppingSectionsFromPage;
            this.pageTeams = data.teams;


            data.teamsForPlaceholder.forEach((item) => {
              

              const virtualId = parseInt(item.key);
              const teamId = parseInt(item.value);
              if (!this.selectedTeamsForPlaceholder[virtualId]) {
                this.selectedTeamsForPlaceholder[virtualId] = [];
              }

              if (this.selectedTeamsForPlaceholder[virtualId].indexOf(teamId) === -1) {
                this.selectedTeamsForPlaceholder[virtualId].push(teamId);
              }
            });


            this.pageTeamIds = [];
            data.teams.forEach(team => {
              this.pageTeamIds.push(team.id)
            });

          }
        } catch (error) {
          console.error("Fehler beim Abrufen der Pages:", error);

          if (error.networkError) console.error("Network Error:", error.networkError);
          if (error.graphQLErrors) console.error("GraphQL Errors:", error.graphQLErrors);
          reject();
        }

        resolve();
      });
    },
    async saveTeam() {
      let placeholder = []
      for (const [key, value] of Object.entries(this.selectedTeamsForPlaceholder)) {
        placeholder.push({
          virtualId: key,
          teamId: value
        })
      }


      let marketIds = [];

      //for each this.marketIds item push it to marketIds only if it is not already in marketIds and not null or undefined
      this.marketIds.forEach(marketId => {
        if (!marketIds.includes(marketId) && marketId !== null && marketId !== undefined) {
          marketIds.push(marketId);
        }
      });
      const pageTeamsData = {
        teamId: this.pageTeamIds,
        pageId: this.pageId,
        placeholder: placeholder,
        marketIds: marketIds
      }
      const mutation = gql`
        mutation editPageTeams($teamPage: PageTeamInput!) {
         editPageTeams(teamPage: $teamPage) {
            success
          }
        }
      `;

      try {
        
        this.isLoading = true;
        const variables = {
          teamPage: pageTeamsData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        this.selectedTeamsForPlaceholder = {};
        await this.getShoppingSectionsFromPage();
        SignalBus.emit("project-reload-purchaser-page");
      } catch (error) {
        console.error("sichern von pageTeams hat nicht funktioniert", error);
      }finally {
        this.isLoading = false;
      }

    },
    async selectShoppingSections() {

      return new Promise(async (resolve, reject) => {


        try {
          // Apollo Client Anfrage
          const response = await apolloClient.query({
            query: gql`
        query getPurchasers {
          getPurchasers {
            id
            name
            teamPosition
            teamIcon
            color
          }
        }
      `,
          });
          this.shoppingSections = response.data.getPurchasers;
          // Überprüfen, ob shoppingSections vorhanden und nicht leer ist
          if (this.shoppingSections && this.shoppingSections.length > 0) {
            // Speichern aller Farben in einer Variablen
            this.colors = this.shoppingSections.map(section => section.color);
          }
        } catch (error) {
          console.error("Fehler beim Abrufen der selectShoppingSections:", error);
          reject();
        }
        resolve();
      });
    },
    toggleTeam(id) {
      const index = this.pageTeamIds.indexOf(id);
      if (index === -1) {
        // id ist nicht im Array
        this.pageTeamIds.push(id);
      } else {
        // id ist bereits im Array
        this.pageTeamIds.splice(index, 1);
      }
    },
    toggleTeamGrid(id) {
      try {

        if (this.selectedTeamsForPlaceholder[this.selectedPlaceholder]?.indexOf(id) >= 0) {
          this.selectedTeamsForPlaceholder[this.selectedPlaceholder].splice(this.selectedTeamsForPlaceholder[this.selectedPlaceholder].indexOf(id), 1);
        } else {
          // entferne alles aus dem Array, und füge das neue hin zu
          this.selectedTeamsForPlaceholder[this.selectedPlaceholder] = [];
          this.selectedTeamsForPlaceholder[this.selectedPlaceholder].push(id);
        }
        this.selectedTeamsForPlaceholder[this.selectedPlaceholder] = this.removeDuplicates(this.selectedTeamsForPlaceholder[this.selectedPlaceholder]);
      } catch (error) {
        console.error("Fehler kein grid ausgewählt:", error, "selectedTeamsForPlaceholder:", this.selectedTeamsForPlaceholder);
      }
    },
    getBackgroundColor(teamColor) {
      // Berechne die Helligkeit der Schriftfarbe
      const color = teamColor.startsWith('#') ? teamColor.substring(1) : teamColor;
      const r = parseInt(color.substr(0, 2), 16);
      const g = parseInt(color.substr(2, 2), 16);
      const b = parseInt(color.substr(4, 2), 16);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;

      // Wähle die Hintergrundfarbe basierend auf der Helligkeit
      return brightness > 125 ? '#000000' : '#FFFFFF';  // Dunkler Hintergrund für helle Schrift und umgekehrt
    },

    removeDuplicates(input) {
      // Konvertiert input in ein Array, falls es nicht bereits eines ist
      let array = Array.isArray(input) ? input : Array.from(input);
      return Array.from(new Set(array));
    },
  },
  mounted() {
    this.selectShoppingSections();
    this.getShoppingSectionsFromPage();
  },
  created() {
    this.selectShoppingSections();
    this.getShoppingSectionsFromPage();
  },
  // watch für pageId
  watch: {
    pageId: async function () {
      await this.selectShoppingSections();
      await this.getShoppingSectionsFromPage();
    },
    selectedPlaceholder: function (value) {
      
    }
  },

}

</script>